module.exports = __webpack_public_path__ + "static/media/logo.14389b95.svg";